import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { RegistrationWaitlistPositionModel } from '../models/registration_waitlist_position_model';
import { IWaitlistStatusDatasource } from '../datasources/waitlist_status_datasource';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ISectionTimesDatasource } from '../../sections/datasources/section_times_datasource';
import { ILocationsDatasource } from '../../sections/datasources/locations_datasource';
import { ICampusesDatasource } from '../../sections/datasources/campuses_datasource';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { ScheduledSectionFilters } from '../filters/scheduled_section_filters';
import * as _4 from 'lodash4';
import { SelectedTimeSliceModel } from '../../../components/time_slice_tiles/models/selected_time_slice_model';

export class ScheduledSectionsQuery implements IQuery {
  private _result: {
    list: ISection[];
    scheduledSections: ISection[];
    scheduledMultiSections: ISection[];
    registeredSections: ISection[];
    registeredMultiSections: ISection[];
    multiSectionsWithTiedUnscheduledSectionTypes: ISection[];
    waitlistedSections: ISection[];
    inProgressSections: ISection[];
    withdrawnSections: ISection[];
    creditsScheduled: number;
    creditsRegistered: number;
  };

  constructor(
    private QueryMediator: IQueryMediator,
    private ngCampusesDatasource: ICampusesDatasource,
    private ngLocationsDatasource: ILocationsDatasource,
    private ngSectionTimesDatasource: ISectionTimesDatasource,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private ngScheduledSectionFilters: ScheduledSectionFilters,
    private ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
    private ngRegistrationWaitlistPositionModel: RegistrationWaitlistPositionModel,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngSelectedTimeSliceModel: SelectedTimeSliceModel
  ) {
    QueryMediator.registerQuery(
      this,
      ngCampusesDatasource,
      ngLocationsDatasource,
      ngSectionTimesDatasource,
      ngTermCoursesDatasource,
      ngSectionsDatasource,
      ngRegisterSectionsDatasource,
      ngWaitlistStatusDatasource,
      ngSelectedTimeSliceModel,
      ngRegistrationWaitlistPositionModel
    );
  }

  // Relation ship
  // Location -> campus -> is_online
  // section_time -> location
  // section_time -> section
  // section -> campus
  // section ->  course

  // Mapping transformation
  // location <- _Campus
  // section_time <- _location
  // section <- section_time
  // section <-  course

  /* TODO: Refactor reduce complexity */
  /* tslint:disable */
  run() {
    const sectionsWithStatus = _4.filter(
      this.ngSectionsDatasource.read(),
      (section) => section.status !== ScheduledSectionStatus.UNSCHEDULED
    );
    const builtScheduledSections = this.ngSectionsDatasource.metasource().composes(sectionsWithStatus);

    const scheduledSections = this.ngScheduledSectionFilters.getScheduledSections(builtScheduledSections);
    const scheduledMultiSections = this.ngScheduledSectionFilters.getScheduledMultiSections(builtScheduledSections);
    const combinedScheduledSections = _4.concat(scheduledSections, scheduledMultiSections);

    const registeredSections = this.ngScheduledSectionFilters.getRegisteredSections(builtScheduledSections);
    const registeredMultiSections = this.ngScheduledSectionFilters.getRegisteredMultiSections(builtScheduledSections);
    const combinedRegisteredSections = _4.concat(registeredSections, registeredMultiSections);

    this._result = {
      list: builtScheduledSections,
      scheduledSections,
      scheduledMultiSections,
      registeredSections,
      registeredMultiSections,
      multiSectionsWithTiedUnscheduledSectionTypes:
        this.ngScheduledSectionFilters.getMultiSectionsWithSiblingUnscheduledSections(builtScheduledSections),
      waitlistedSections: this.ngScheduledSectionFilters.getWaitlistedSections(builtScheduledSections),
      withdrawnSections: this.ngScheduledSectionFilters.getWithdrawnSections(builtScheduledSections),
      inProgressSections: this.ngScheduledSectionFilters.getInProgressSections(builtScheduledSections),
      creditsScheduled: _4.reduce(
        _4.uniqBy(combinedScheduledSections, 'course'),
        (sum, n) => sum + _4.get(n, '_course.credits', 0),
        0
      ),
      creditsRegistered: _4.reduce(
        _4.uniqBy(combinedRegisteredSections, 'course'),
        (sum, n) => sum + _4.get(n, '_course.credits', 0),
        0
      )
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngScheduledSectionsQuery', ScheduledSectionsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/queries/scheduled_sections_query.ts